const pageIndexes = {
    MIN_FLOW_INDEX: 0,
    MAX_FLOW_INDEX: 3
};

export enum CLASS_REDUCER{
    CHANGE_STATE = 'changeState',
    PAGE_LOADED='setClassificationPageLoaded',
    CLOSE_MAIL='closeMailPopUp',
    CLOSE_ERROR='closeErrorPopup',
    SET_ERROR='setErrorPopup',
    MOVE_NEXT='increaseIndex',
    MOVE_BACK='decreaseIndex',
    START_TRAIN='startTrain'
}

export default {
    pageIndexes
};
